module.exports = __webpack_public_path__ + "img/mispos_charact_1.add92622.svg";